import { isEmpty, isNull } from 'lodash-es';
import { Paragraph } from '../../lib/ds/typography/typography';
import { ErgebnisProtokoll } from './ergebnisprotokoll';
import type { AufgabeAbschliessenModel } from './model';

type AufgabenDetailsProps = {
  aufgabe: AufgabeAbschliessenModel | null;
};

export const AufgabenDetails = ({ aufgabe }: AufgabenDetailsProps) => {
  if (isNull(aufgabe)) {
    return null;
  }

  return (
    <>
      {isEmpty(aufgabe.details) ? null : <Paragraph aria-label="Aufgabendetails">{aufgabe.details}</Paragraph>}
      <ErgebnisProtokoll aufgabe={aufgabe} />
    </>
  );
};
